import React, { Component } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Tooltip, withStyles} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import firebase from '../../firebase'

const styles = theme => ({
    paper: {
        padding: 16,
        margin: theme.spacing(2),
        // height: '100%',
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    absolute: {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
        // position: 'absolute',
        // bottom: theme.spacing(2),
        // right: theme.spacing(3),
    },
})

class CreateItem extends Component{

    constructor(props) {
        super(props)

        this.state = {
            editMode: false,
            id: "",
            open: false,
            name: "",
            time: "",
            imageUrl: "",
            error: false,
            value: null
        }

        this.database = firebase.database().ref().child('categories')
    }

    componentDidMount() {
        const {editMode, item } = this.props
        if (editMode === true) {
            console.log(editMode)
            const { id, name, time, imageUrl } = item
            this.setState({
                editMode: editMode,
                id: id,
                name: name,
                time: time,
                imageUrl: imageUrl,
            })
        }
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSubmit = () => {
        //TODO:- Validate the form!
        const { editMode, id, name, time, imageUrl } = this.state
        
        if (editMode) {
            this.updateItemData(id, name, time, imageUrl)
        } else {
            this.writeUserData(name, time, imageUrl)
        }
        
    }

    updateItemData = (id, name, time, imageUrl) => {
        this.database.child(id).update({
            name: name,
            time: time ? time : "",
            imageUrl: imageUrl,
        })

        this.setState({
            open: false,
        })
    }

    writeUserData = (name, time, imageUrl) => {
        this.database.push({
            name: name,
            time: time,
            imageUrl: imageUrl, 
            visible: true
        })

        this.setState({
            open: false,
            name: "",
            time: "",
            imageUrl: "",
            error: false, 
            value: null
        })
    }


    handleChange = name => event => {
        this.setState({
            [name] : event.target.value
        })
    }

    render() {
        const { open, name, time, imageUrl, error } = this.state
        const { editMode, classes } = this.props
        return (
            <div>
                {
                    editMode ? 
                        <Button size="small" color="primary" onClick={this.handleClickOpen}>
                            Edit
                        </Button>
                        :
                        // <Button color="inherit" onClick={this.handleClickOpen}>New Item</Button>
                        // <Fab size="small" aria-label="add" onClick={this.handleClickOpen}>
                        //     <AddIcon />
                        // </Fab>
                        <Tooltip title="Add">
                            <Fab color="secondary" className={classes.absolute} onClick={this.handleClickOpen}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>

                }
                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle id="form-dialog-title">{editMode ? "Edit Category" : "Create a New Category"}</DialogTitle>
                    <DialogContent>
                        <form>
                            <TextField
                                autoFocus
                                error={error && name === ""}
                                margin="normal"
                                id="name"
                                label="Item Name"
                                type="text"
                                value={name}
                                onChange={this.handleChange('name')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                required
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                id="time"
                                label="Time"
                                type="text"
                                value={time}
                                onChange={this.handleChange('time')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                id="imageUrl"
                                label="Image URL"
                                type="text"
                                value={imageUrl}
                                onChange={this.handleChange('imageUrl')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                        </form>
                    </DialogContent>
                    <DialogActions style={{ marginRight: 16, marginBottom: 8,}}>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" onClick={this.handleSubmit} color="primary">
                            {editMode ? "Update" : "Add"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(CreateItem)